/**
 * Cidades Convenio
 *      Rotas
 *          - api/convenio/estados
 */
import UtilsFael from '@lib/utilsFael'
import Axios from 'axios'
import qs from 'qs'

const STORAGE_NAME = 'latlng_estados_unidades';

export default class Estado {
    constructor(estado) {
        this.__original = estado
    }

    getEstadoUnidadesFromLocalStorage(uf) {
        try {
            let estadosUnidades = localStorage.getItem(STORAGE_NAME)
            return JSON.parse(estadosUnidades).find(estado => estado.uf == uf)
        } catch (error) {
            return null
        }
    }
    
    setEstadoUnidadesToLocalStorage(estado) {
        try {
            let estadosUnidades = JSON.parse(localStorage.getItem(STORAGE_NAME))
            estadosUnidades.push(estado)
            localStorage.setItem(STORAGE_NAME, JSON.stringify(estadosUnidades))
        } catch (error) {
            localStorage.setItem(STORAGE_NAME, JSON.stringify([estado]))
        }
    }

    async setLatLng() {
        let params = {
            address: `${this.nome} - Brasil`,
            key: UtilsFael.google_maps_api
        }
        await Axios
            .get(`https://maps.googleapis.com/maps/api/geocode/json?${qs.stringify(params)}`)
            .then(response => {
                if (response.data.results.length) {
                    this.setEstadoUnidadesToLocalStorage({
                        uf: this.uf,
                        latlng: response.data.results[0].geometry.location
                    })
                }
            })
    }

    /**
     * @returns {string}
     */
    get id() {
        return this.__original.id || ''
    }

    /**
     * @returns {string}
     */
    get uf() {
        return this.__original.nome || ''
    }

    /**
     * @returns {string}
     */
    get nome() {
        return UtilsFael.getEstadoByUF(this.__original.nome, true)
    }

    /**
     * @returns {object}
     */
    get latlng() {
        let estadoLocal = this.getEstadoUnidadesFromLocalStorage(this.uf)
        if (estadoLocal)
            return estadoLocal.latlng
        return {}
    }
}